import { createContext } from 'react';
import { HotjarContext } from './types';

export const initialContext: HotjarContext = {
  trigger: () => {},
  triggerEvent: () => {},
};

export default createContext(initialContext);
